import React, { FC } from 'react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { PrimitiveType, FormatXMLElementFn } from 'intl-messageformat';

import { ILanguageReducer } from '../../reducers/languageReducer';
import { IState } from '../../reducers';

interface IProps {
    id: string;
    defaultMessage?: string;
    values?: Record<string, any>;
    tagName?: React.ElementType<any>;
}

const IntlMessage: FC<IProps> = props => {
    const { translations, userLanguage } = useSelector<IState, ILanguageReducer>(state => state.language);
    const hasTranslation = !!translations?.[userLanguage]?.[props.id];
    let selectedId = props.id;
    if (!hasTranslation && userLanguage >= 0 && !props.defaultMessage) {
        selectedId = 'global.defaultMessage';
    }
    return (
        <FormattedMessage id={selectedId} defaultMessage={props.defaultMessage} values={props.values} tagName={props.tagName} />
    );
};

export default IntlMessage;

export const useIntlMessage = () => {
    const intl = useIntl();
    const { translations, userLanguage } = useSelector<IState, ILanguageReducer>(state => state.language);

    const intlFormatMessage = (data: MessageDescriptor, values?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>) => {
        const hasTranslation = !!translations?.[userLanguage]?.[data.id];
        let selectedId = data.id;
        if (!hasTranslation && userLanguage >= 0 && !data.defaultMessage) {
            selectedId = 'global.defaultMessage';
        }
        return intl.formatMessage({ ...data, id: selectedId }, values || undefined);
    };

    return { intlFormatMessage };
};